import TaskManagerEditDto from './TaskManagerEditDto';
import DataSplitTaskFieldEditDto from './DataSplitTaskFieldEditDto';

export class OptimizationCaseTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {Object} */
        this.lastResult = null;

        /** @type {number} */
        this.optimizationCase = null;
    }

    /**
     * @typedef {Object} _OptimizationCaseTaskEditDto Props
     * 
     * @property {number} lastResult
     * @property {number} optimizationCase
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _OptimizationCaseTaskEditDto Props} OptimizationCaseTaskEditDto Props
     */
    /**
     *
     * @param {OptimizationCaseTaskEditDto Props} props
     * @returns {OptimizationCaseTaskEditDto }
     */
    setup(props) {
        super.setup(props);

        this.lastResult = props.lastResult;
        this.optimizationCase = props.optimizationCase;

        return this;
    }
}

export default OptimizationCaseTaskEditDto;
